import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import VisibilityIcon from '@material-ui/icons/Visibility'
import * as Common from '@tfo/common'
import { DiscrepancyIndicator } from '@tfo/common'
import { IOrderClient } from '@tfo/common/src/models'
import { observer } from 'mobx-react'
import { useState } from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { displayNationalId } from '../../../../../../../utils/NationalId'
import '../ReportsItem.scss'
import ReportsItemDate from './ReportsItemDate'
import ReportsItemOngoingOrderDialog from './ReportsItemOngoingOrderDialog'

export interface ReportsItemOngoingProps {
    data: Common.models.IOrderClient
    onClick: any
    reportPackages: Common.models.ReportPackage[]
    showCompanyName: boolean
    onRemoveOrder: (order: IOrderClient) => void
}

const ReportsItemOngoing = ({ data, intl, onClick, reportPackages, showCompanyName, onRemoveOrder }: ReportsItemOngoingProps & WrappedComponentProps) => {
    const [ongoingOrderModal, setOngoingOrderModal] = useState<boolean>(false)

    const toggleOngoingOrderModal = (): void => {
        setOngoingOrderModal(!ongoingOrderModal);
    }

    const RenderCells = (props) => {
        return (
            <>
                {props.showCompanyName && (
                    <div className={'ReportsItem__Cell'}>{props.data.companyName}</div>
                )}

                <div className={'ReportsItem__Cell'}>
                    {props.reportPackages.find(x => x.id === props.data.servicePackageId)?.customName ?? ''}
                </div>
                <div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
                    {props.data.candidate?.firstName}
                </div>
                <div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
                    {props.data.candidate?.lastName}
                </div>
                <div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
                    {displayNationalId(props.data.candidate)}
                </div>
                <ReportsItemDate
                    date={props.data.availableFrom}
                    label={intl.formatMessage({ id: 'common.delivery' })}
                />
            </>
        )
    }

    return (
        <>
            {
                data?.partiallyDelivered && onClick ? (
                    <div
                        className={'ReportsItem ReportsItem--standard ReportsItem--active'}
                        id={'reportsItem_' + data.id.toString()}>
                        <div className={'ReportsItem__Inner'} onClick={onClick} >
                            <Tooltip title={intl.formatMessage({ id: 'common.partiallyDelivered.preview', })}>
                                <VisibilityIcon fontSize='large' htmlColor='#7D7D7C' style={{ position: 'absolute', left: '-40px' }} />
                            </Tooltip>
                            <RenderCells data={data} showCompanyName={showCompanyName} reportPackages={reportPackages} />
                        </div>
                        {!!data.reportSummary && (
                            <DiscrepancyIndicator
                                title={intl.formatMessage({ id: 'common.reportWithDiscrepancy' })}
                                body=""
                                className='	ReportsItem__ReportSummary' />
                        )}
                    </div>
                ) : (
                    <>
                        <div
                            className={'ReportsItem ReportsItem--standard ReportsItem--active'}
                            id={'reportsItem_' + data.id.toString()}>
                            <div className={'ReportsItem__Inner'} onClick={() => toggleOngoingOrderModal()}>
                                <RenderCells data={data} showCompanyName={showCompanyName} reportPackages={reportPackages} />
                            </div>
                        </div>

                        <ReportsItemOngoingOrderDialog open={ongoingOrderModal} selectedOrder={data} reportPackages={reportPackages} onClose={toggleOngoingOrderModal} removeOrder={onRemoveOrder} />
                    </>
                )
            }
        </>
    )
}
export default injectIntl(observer(ReportsItemOngoing))
